module.exports = __webpack_public_path__ + "Roboto-normal-700.525d5b452809b3172a2a.woff";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/Roboto-normal-700.woff
// module id = 907
// module chunks = 2